<div class="form" [formGroup]="form()">
  <div class="row">
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="name"
      [label]="'withdrawal.bankTransferINR.name.label' | translate"
      [placeholder]="'withdrawal.bankTransferINR.name.placeholder' | translate"
    />
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="surname"
      [label]="'withdrawal.bankTransferINR.surname.label' | translate"
      [placeholder]="
        'withdrawal.bankTransferINR.surname.placeholder' | translate
      "
    />
  </div>
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="accountNumber"
    [label]="'withdrawal.bankTransferINR.accountNumber.label' | translate"
    [placeholder]="
      'withdrawal.bankTransferINR.accountNumber.placeholder' | translate
    "
  />
  <div class="row">
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="bankIfsc"
      [label]="'withdrawal.bankTransferINR.bankIfsc.label' | translate"
      [placeholder]="'withdrawal.bankTransferINR.name.placeholder' | translate"
    />
    <fu-simple-input
      [useOutlineLabel]="false"
      formControlName="bankName"
      [label]="'withdrawal.bankTransferINR.bankName.label' | translate"
      [placeholder]="
        'withdrawal.bankTransferINR.bankName.placeholder' | translate
      "
    />
  </div>
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="description"
    [label]="'withdrawal.bankTransferINR.description.label' | translate"
    [placeholder]="
      'withdrawal.bankTransferINR.description.placeholder' | translate
    "
  />
</div>
